import React from "react";
import clsx from "clsx";
import DesignEditor from '../DesignEditor';
import Sidebar from "../Sidebar";
import ErrorHelper from "../../Errors/ErrorHelper";
import MessageBuilderImageGroup from '../MessageBuilderImageGroup'
import Tabs from "../../Tabs/Tabs";

export default class MessageBuilderGeneral extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      editor_active_tab: 'editor'
    }
    this.setActiveTab = this.setActiveTab.bind(this);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true,
      'row': true
    })

    return (
      <div className={tabClasses} id="general">
        {ErrorHelper.renderErrors(this.props.errors, ['code', 'name', 'time_period', 'to', 'body'])}
        <div className="row" style={{height: '100%'}}>
          <input type="hidden" name="email[editor_type]" value={this.props.email && this.props.email.editor_type ? this.props.email.editor_type : ''} />

          <div className="col-sm-3">
            <Sidebar {...this.props} />
          </div>

          <div className="col-sm-9" style={{height: '100%'}}>
            <Tabs
              tabs={this.tabs()}
            />
            <div className="tab-content">
              {<DesignEditor {...this.state} {...this.props} folio_item_types={this.props.folio_item_types} survey_forms={this.props.survey_forms}/>}
              {<MessageBuilderImageGroup {...this.props} {...this.state} onChangeImages={this.props.onChangeImages} images_data_table_path={this.props.paths.images_data_table_path}></MessageBuilderImageGroup>}
            </div>
          </div>
        </div>
      </div>
    );
  }

  tabs() {
    var tabs = [];

    tabs.push({
      tabName: I18n.t("editor"),
      targetName: "editor",
      classes: this.state.editor_active_tab === "editor" ? "active" : null,
      changeHandler: this.setActiveTab,
    });

    tabs.push({
      tabName: I18n.t("images"),
      targetName: "images",
      classes: this.state.editor_active_tab === "images" ? "active" : null,
      changeHandler: this.setActiveTab,
    });

    return tabs;
  }

  setActiveTab(tab) {
    this.setState({editor_active_tab: tab});
  }
};